import React, { useEffect, useState } from 'react';
import { lactoMamaKey } from '../../src/Constants/GeneralItemsKeys';
import {
  getDiscussionJSONLdData,
  getFilteredCategoryContent,
  getReviewJSONLdData,
  getWebUserId,
  replaceUnderscore,
} from '../../src/Utils/helper';
import LactoMamaPageOuter from '../../src/components/LactoMamaPage/LactoMamaPageOuter';
import {
  categoryNavBarDataFetcher,
  tabByKeyFetcher,
} from '../../src/datafetchers/CategoryPage';
import {
  checkProductSddNddEligiblity,
  discussionFetcher,
  productFetcher,
  productPriceFetcher,
  reviewFetcher,
} from '../../src/datafetchers/productPage';
import { PDPDiscussionData } from '../../src/Utils/productPageUtils';
import { getWebUserType } from '../../src/Utils/getWebUserType';

const defaultProductId = '3928';

export async function getStaticProps(context) {
  const category = lactoMamaKey;

  // const selectedVariant = context?.query?.title?.replace(/"/g, '') || 'Elaichi'; // Remove quotes and default to Elaichi
  // const selectedProductId = context?.query?.product_id || defaultProductId;
  const selectedVariant = 'Elaichi';
  const selectedProductId = defaultProductId;

  let ReviewJSONLDData = [];
  let DiscussionJSONLDData = [];
  let generalItemsData = await tabByKeyFetcher({
    key: replaceUnderscore(category),
    type: context?.query?.type,
    userType: 'A',
  });

  const categoryNavBarApiData = await categoryNavBarDataFetcher();
  const productData = await productFetcher(
    `api/getProduct/${selectedProductId}`,
  );

  // Extract flavour titles from productData
  const getUniqueFlavourTitles = () => {
    // Loop through each variant option group
    const allFlavourTitles = [];

    productData?.data?.variantOption.forEach((variantGroup) => {
      if (variantGroup.variant_type === 'Flavour' && variantGroup.data) {
        // Extract titles from the data array
        const titlesFromGroup = variantGroup.data
          .map((item) => item.title)
          .filter(Boolean);
        allFlavourTitles.push(...titlesFromGroup);
      }
    });

    // Get unique titles
    const uniqueTitles = [...new Set(allFlavourTitles)];

    return uniqueTitles;
  };

  const flavourTitles = getUniqueFlavourTitles();

  // Fetch general items data for each flavour
  let generalItemsDataByFlavour = {};

  for (const flavourTitle of flavourTitles) {
    // Fix: If flavourTitle is "Elaichi", use only category, otherwise append flavourTitle
    const categoryKey =
      flavourTitle === 'Elaichi'
        ? replaceUnderscore(category)
        : `${replaceUnderscore(category)}_${flavourTitle}`;

    // const categoryKey = flavourTitle != "Elaichi" ? replaceUnderscore(category) : `${replaceUnderscore(category)}_${flavourTitle}`;

    try {
      const flavourData = await tabByKeyFetcher({
        key: categoryKey,
        type: context?.query?.type,
        userType: 'A',
      });

      generalItemsDataByFlavour[flavourTitle] = flavourData?.data;
    } catch (error) {
      generalItemsDataByFlavour[flavourTitle] = null;
    }
  }
  // console.log('generalItemsDataByFlavour:', generalItemsDataByFlavour);
  for (const key of Object.keys(generalItemsDataByFlavour)) {
    if (key.toLowerCase() === selectedVariant.toLowerCase()) {
      generalItemsData = { data: generalItemsDataByFlavour[key] };

      break;
    }
  }

  const reviewData = await reviewFetcher(defaultProductId, true);
  const discussionData = await discussionFetcher(defaultProductId, true);
  DiscussionJSONLDData = getDiscussionJSONLdData(discussionData);
  const { ReviewJSONData } = getReviewJSONLdData(reviewData);
  ReviewJSONLDData = ReviewJSONData;

  return {
    props: {
      generalItemsData: generalItemsData?.data,
      generalItemsDataByFlavour: generalItemsDataByFlavour, // Add this line
      flavourTitles: flavourTitles, // Add this line
      selectedVariant: selectedVariant,
      selectedProductId: selectedProductId,
      categoryData: getFilteredCategoryContent(categoryNavBarApiData?.data),
      productData: productData?.data,
      ReviewJSONLDData: ReviewJSONLDData,
      DiscussionJSONLDData:
        PDPDiscussionData[defaultProductId] || DiscussionJSONLDData,
    },
    revalidate: 60,
  };
}

function LactoMamaPage(props) {
  const {
    categoryData,
    generalItemsData,
    generalItemsDataByFlavour, // Add this line
    flavourTitles, // Add this line
    selectedVariant,
    selectedProductId,
    productData,
    ReviewJSONLDData,
    DiscussionJSONLDData,
  } = props;
  const [generalItems, setGeneralItems] = useState(generalItemsData);
  const [productPriceData, setProductPriceData] = useState(null);
  const [sddNddData, setSddNddData] = useState(null);
  const [tabThemeColor, setTabThemeColor] = useState(
    generalItemsData.tabThemeColor || '#498A5B',
  );
  const [tabThemeSecondaryColor, setTabThemeSecondaryColor] = useState(
    generalItemsData.tabThemeSecondaryColor || '#E2FFEA',
  );
  const [productVariantData, setProductVariantData] = useState(productData);

  let variantDataForPopup = [];
  productData?.variantData?.forEach((variant) => {
    variantDataForPopup.push({
      name: variant.title,
      title: variant.title,
      desc: '',
      image: variant.image_path,
      skuId: variant.id,
      price: variant.price,
      strikePrice: variant.strikePrice,
      status: variant.status,
      bestSeller: variant.id == 3928,
      ppuText: variant.ppuText,
    });
  });

  const showNewLactoPage = true;

  const fetchProductPrice = async () => {
    const apiParams = {
      product_id: selectedProductId || defaultProductId,
      type: '',
      userType: getWebUserType(),
    };
    const productResp = await productPriceFetcher(apiParams);

    setProductPriceData(productResp?.data);
    if (productResp?.data) {
      productData.variantOption = productResp?.data?.variantOption;
      setProductVariantData(productData);
    }
  };

  useEffect(() => {
    fetchProductPrice();
  }, []);

  const addSddNddCard = async () => {
    const body = {
      productId: productData?.id.toString(),
      totalOrderValue: productData?.price,
      webUserId: getWebUserId(),
      userType: getWebUserType(),
    };
    const resp = await checkProductSddNddEligiblity(body);
    if (resp?.data?.NddSddEligible) {
      setSddNddData(resp?.data);
    }
  };

  useEffect(() => {
    let generalItemsNew = [];
    if (showNewLactoPage) {
      const bottomItems = [];
      let bottomItemsInsertIndex = -1;
      for (const innerItem of generalItemsData.items) {
        if (innerItem._id == 5925) {
          continue;
        }
        if (innerItem._id == 5927) {
          bottomItems.push(innerItem);
        } else {
          generalItemsNew.push(innerItem);
        }
      }
      for (const [index, innerItem] of generalItemsNew.entries()) {
        if (innerItem._id == 5956) {
          bottomItemsInsertIndex = index;
          break;
        }
      }

      if (bottomItemsInsertIndex != -1) {
        generalItemsNew.splice(bottomItemsInsertIndex + 1, 0, ...bottomItems);
      }

      generalItemsData.items = generalItemsNew;
    } else {
      generalItemsNew = generalItemsData.items.filter(
        (obj) => obj._id != 5955 && obj._id != 5956,
      );
      generalItemsData.items = generalItemsNew;
    }
    setGeneralItems(generalItemsData);
    addSddNddCard();
  }, []);

  return (
    <LactoMamaPageOuter
      generalItemsData={generalItems}
      generalItemsDataByFlavour={generalItemsDataByFlavour} // Add this line
      flavourTitles={flavourTitles}
      categoryData={categoryData}
      productData={productVariantData}
      variantDataForPopup={variantDataForPopup}
      offerData={productPriceData?.offers}
      showNewLactoPage={showNewLactoPage}
      productPriceData={productPriceData}
      ReviewJSONLDData={ReviewJSONLDData}
      DiscussionJSONLDData={DiscussionJSONLDData}
      sddNddData={sddNddData}
      setGeneralItems={setGeneralItems}
      setTabThemeColor={setTabThemeColor}
      tabThemeColor={tabThemeColor}
      tabThemeSecondaryColor={tabThemeSecondaryColor}
      setTabThemeSecondaryColor={setTabThemeSecondaryColor}
      selectedProductId={selectedProductId}
    />
  );
}

export default LactoMamaPage;
